import getPropsValuesMixin from "@/helpers/Maps/getPropsValuesMixin.js";
import propsBinder from "@/helpers/Maps/propsBinder.js";
import _ from "lodash";
import MapElementMixin from "./maps-mixin";

const props = {
    path: {
        type: Object
    }
};


export default {
  mixins: [MapElementMixin, getPropsValuesMixin],
  props: props,

  render() { return ''; },

  destroyed () {
    if (this.$polylineObject) {
      this.$polylineObject.setMap(null);
    }
  },

  async deferredReady() {
    const options = _.clone(this.getPropsValues());
    delete options.options;
    _.assign(options, this.options);
    //this.$polylineObject = new window.google.maps.Polyline(options);
    //this.$polylineObject.setMap(this.$map);

    const { encoding } = await window.google.maps.importLibrary("geometry");
    var routePath = encoding.decodePath(options.path.encodedPolyline);
    this.$polylineObject = new window.google.maps.Polyline({ path: routePath, geodesic: true, strokeColor: "#00AA00", strokeOpacity: 0.8, strokeWeight: 4, });
    propsBinder(this, this.$polylineObject, _.omit(props, ['deepWatch', 'path']));

    var clearEvents = () => {};
    console.log("PATH:", options.path)
    this.$watch('path',async (path) => {
      if (path) {
        clearEvents();
        const { encoding } = await window.google.maps.importLibrary("geometry");
        var routePath = encoding.decodePath(path.encodedPolyline);
        this.$polylineObject = new window.google.maps.Polyline({ path: routePath, geodesic: true, strokeColor: "#00AA00", strokeOpacity: 0.8, strokeWeight: 4, });
        const eventListeners = [];
        clearEvents = () => {
            this.$polylineObject.setMap(null);
            eventListeners.map(([obj, listenerHandle]) => // eslint-disable-line no-unused-vars
            window.google.maps.event.removeListener(listenerHandle));
        };
      }
    }, {
      deep: this.deepWatch
    });
    var latlng = [
      new window.google.maps.LatLng(options.path.startLocation.lat, options.path.startLocation.lng),
      new window.google.maps.LatLng(options.path.endLocation.lat, options.path.endLocation.lng),
    ]; 
    var latlngbounds = new window.google.maps.LatLngBounds();
    for (var i = 0; i < latlng.length; i++) {
        latlngbounds.extend(latlng[i]);
    }
    // Display the map
    this.$polylineObject.setMap(this.$map);
    this.$map.fitBounds(latlngbounds);
  },
};